import React from 'react';
import { useSelector } from 'react-redux';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { seriesTabs } from './helpers';

const SeriesTabs = () => {
	const { languages } = useSelector(
		({ content_translations }) => content_translations.language_list
	);

	return <Tabs tabs={seriesTabs(languages)} />;
};

export default SeriesTabs;
